<template>
  <a-modal title="获取体验账号" :visible="visible" :footer="null" @ok="handleOk" @cancel="handleCancel"
    class="experience-modal">
    <a-form-model ref="ruleForm" :model="form" :rules="rules">
      <a-form-model-item label="名称" prop="name">
        <a-input v-model="form.name" placeholder="请输入用户名称" />
      </a-form-model-item>
      <a-form-model-item label="手机号" prop="loginAccountMobile">
        <a-input v-model="form.loginAccountMobile" placeholder="请输入手机号" type="number" ref="inputMobile"
          autocomplete="off" :maxLength="11" @change="onInputMobile" />
      </a-form-model-item>
      <a-form-model-item label="验证码" prop="verifyCode">
        <a-input v-model="form.verifyCode" placeholder="请输入验证码" class="input-vcode" />
        <div class="verification-code" :class="form.loginAccountMobile.length == 11 ? 'basic-code-active' :''"
          @click="btnVerificationCode">{{ time>0?time+'S后重试' :'获取验证码' }}</div>
      </a-form-model-item>
      <a-form-model-item label="请选择身份" prop="identity">
        <a-radio-group v-model="form.identity" @change="onChangeIdentity">
          <a-radio :value="0">维修厂</a-radio>
          <a-radio :value="1">配件店</a-radio>
          <a-radio :value="2">其他</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="所在区域">
        <div class="basic-form-flex">
          <a-select @change="handleChangeProveice" placeholder="请选择省" class="basic-select" :disabled="provinceDisable"
            v-decorator="['provinceId', { rules: [{ required: true, message: '请选择省' }] }]">
            <a-icon slot="suffixIcon" type="caret-down" style="color: #555555" />
            <a-select-option v-for="item in provinceList" :key="item.id">{{item.name}}</a-select-option>
          </a-select>
          <a-select @change="handleChangeCity" placeholder="请选择市" :disabled="cityDisabled" class="basic-select"
            v-decorator="['cityId', { rules: [{ required: true, message: '请选择省' }] }]">
            <a-icon slot="suffixIcon" type="caret-down" style="color: #555555" />
            <a-select-option v-for="item in cityList" :key="item.id">{{item.name}}</a-select-option>
          </a-select>
          <a-select @change="handleChangeCounty" placeholder="请选择区" :disabled="countyDisabled" class="basic-select"
            v-decorator="['countyId', { rules: [{ required: true, message: '请选择省' }] }]">
            <a-icon slot="suffixIcon" type="caret-down" style="color: #555555" />
            <a-select-option v-for="item in countyList" :key="item.id">{{item.name}}</a-select-option>
          </a-select>
        </div>
      </a-form-model-item>
    </a-form-model>
    <div class="experience-account">
      <a-button type="primary" @click="getExperienceAccount">
        获取体验账号
      </a-button>
      <!-- <div class="agreement">
        <a-checkbox @change="onChangeAgreementChecked" :checked="agreementChecked">阅读并同意《服务协议和隐私政策》</a-checkbox>
      </div> -->
      <div class="go-login">
        <span style="color: #888888;">已有账号？</span>
        <span style="color: #F76F14; cursor: pointer;" @click="handleCancel">登录</span>
      </div>
    </div>
  </a-modal>
</template>
<script>
import { sendCode, getListAreaByParentIdNoToken, getAccountRegister } from "@/utils/api";
export default {
  data() {
    return {
      visible: false,
      rules: {
        name: [{ required: true, message: "请输入手机号" }],
        loginAccountMobile: [{ required: true, message: "请输入手机号" }],
        verifyCode: [{ required: true, message: "请输入验证码" }],
        identity: [{ required: true, message: "请选择身份" }],
      },
      form: {
        name: "",
        loginAccountMobile: "",
        verifyCode: "",
        smsKey: "",
        provinceId: "",
        cityId: "",
        countyId: "",
      },

      provinceDisable: false,
      cityDisabled: false,
      countyDisabled: false,

      timer: null,
      time: 0,

      identityValue: 1,
      provinceList: [],
      cityList: [],
      countyList: [],
      areaId: "",
    };
  },
  methods: {
    show() {
      this.form.mobile = "";
      this.form.verifyCode = "";
      this.visible = true;
      this.getAreaList(1);
    },
    /**
     * 描述: 获取省市区数据
     */
    getAreaList(index) {
      let data = {
        parentId: this.areaId,
      };
      let header = {
        token: "",
      };
      data = this.$qs.stringify(data);
      getListAreaByParentIdNoToken(data, header).then((res) => {
        if (res.success) {
          res.result.forEach((item) => {
            item.label = item.name;
            item.value = item.id;
          });
          if (index == 1) {
            this.provinceList = res.result;
          } else if (index == 2) {
            this.cityList = res.result;
          } else {
            this.countyList = res.result;
          }
        }
      });
    },

    /**
     * 描述: 获取验证码
     */
    btnVerificationCode() {
      if (!this.timer) {
        if (!this.isEmpty(this.form.mobile)) {
          let data = new FormData();
          data.append("mobile", this.form.mobile);
          sendCode(data, {
            token: "",
          }).then((res) => {
            if (res.success) {
              this.form.smsKey = res.result.key;
              this.$message.success("信息已经发到您的手机上了~");
              this.resetTime();
            }
          });
        } else {
          this.$message.warn("请输入手机号");
        }
      } else {
        this.$message.success("信息已经发到您的手机上了~");
      }
    },

    /**
     * 描述：60s 倒计时
     */
    resetTime() {
      this.time = 60;
      this.timer = setInterval(() => {
        if (this.time > 0) {
          this.time--;
        } else {
          clearInterval(this.timer);
          this.timer = null;
          this.time = 0;
        }
      }, 1000);
    },
    /**
     * 描述：验证手机号格式
     */
    onInputMobile() {
      setTimeout(() => {
        this.form.mobile = this.$refs.inputMobile.value;
        console.log(this.form.mobile);
      }, 20);
    },
    /**
     * 描述：选择体验用户身份
     */
    onChangeIdentity(e) {
      console.log(e.target.value);
      this.form.identity = e.target.value;
    },
    /**
     * 描述：所在区域省
     */
    handleChangeProveice(e) {
      this.provinceList.map((item) => {
        if (e == item.id) {
          this.form.provinceId = item.id;
          this.form.provinceName = item.name;
        }
      });
      this.areaId = e;
      this.cityDisabled = false;
      this.getAreaList(2);
    },
    /**
     * 描述：所在区域市
     */
    handleChangeCity(e) {
      this.cityList.map((item) => {
        if (e == item.id) {
          this.form.cityId = item.id;
          this.form.cityName = item.name;
        }
      });
      this.areaId = e;
      this.countyDisabled = false;
      this.getAreaList(3);
    },
    /**
     * 描述：所在区县
     */
    handleChangeCounty(e) {
      this.countyList.map((item) => {
        if (e == item.id) {
          this.form.countyId = item.id;
          this.form.countyName = item.name;
        }
      });
    },
    /**
     * 描述：确认选择获取体验账号
     */
    getExperienceAccount() {
      console.log(this.form);
      this.$refs.ruleForm.validate((valid) => {
        console.log(valid);
        if (valid) {
          this.form.detailAddress = this.form.provinceName + this.form.cityName + this.form.countyName;
          getAccountRegister(this.form).then((res) => {
            console.log(res);
          });
        }
      });
    },
    /**
     * 描述：取消并关闭弹框
     */
    handleCancel() {
      this.visible = false;
    },
    handleOk() {},
  },
};
</script>

<style lang="scss">
.input-vcode {
  width: 254px !important;
}
.experience-modal {
  width: 620px !important;
  height: 560px !important;
  .ant-modal-title {
    font-size: 18px;
  }
  .ant-modal-body {
    padding: 0px 75px 0 75px;
  }
  .ant-form-item {
    height: 60px;
    display: flex;
    margin-bottom: 0 !important;
    .ant-form-item-label {
      width: 86px;
      text-align: right;
    }
    .ant-form-item-control-wrapper {
      .ant-input {
        width: 360px;
        height: 36px !important;
        line-height: 34px !important;
        border-radius: 2px !important;
      }
      .ant-radio-group {
        padding-left: 10px;
      }
      .basic-form-flex {
        display: flex;
        .basic-select {
          width: 115px !important;
          margin-right: 6px;
        }
        .basic-select:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .experience-account {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 16px;
    .ant-btn-primary {
      width: 320px !important;
      height: 46px !important;
      font-size: 16px;
    }
    .agreement {
      width: 320px;
      margin-top: 16px;
      span {
        color: #888888;
        font-size: 14px;
      }
    }
    .go-login {
      margin-top: 24px;
      font-size: 16px;
    }
  }
  .basic-code-active {
    background-color: var(--co) !important;
    color: #fff !important;
  }
  .verification-code {
    display: inline-block;
    width: 100px;
    margin-left: 6px;
    background-color: #fafafa;
    height: 36px;
    line-height: 34px;
    text-align: center;
    color: #aaaaaa;
    border-radius: 2px;
    border: 1px solid #e6e6e6;
    cursor: pointer;
    outline: none;
  }
}
</style>
